import { render } from "./TratamientoForm.vue?vue&type=template&id=2cab4e39&scoped=true"
import script from "./TratamientoForm.vue?vue&type=script&lang=js"
export * from "./TratamientoForm.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=2cab4e39&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cab4e39"]])

export default __exports__